import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-view-company',
  templateUrl: './icon-view-company.component.html',
  styleUrls: ['./icon-view-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconViewCompanyComponent {}
